//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { AnySpecificPaymentMethodResponse } from './interface/any-specific-payment-method-response';
import { AllPaymentMethodDiscriminators } from './interface/all-payment-method-discriminators';

const URL = import.meta.env.VITE_PAYMENT_MANAGEMENT_API || `${window.location.origin}/managed-payments/api`;

export interface IBankDetailsClient {
	/**
	 * Change Bank Details.
	 * @param body (optional)
	 * @return Change Bank Details Response
	 */
	changeBankDetails(body: ChangeBankDetailsCommand | undefined): Promise<ChangeBankDetailsResponse>;
}

export class BankDetailsClient implements IBankDetailsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Change Bank Details.
	 * @param body (optional)
	 * @return Change Bank Details Response
	 */
	changeBankDetails(
		body: ChangeBankDetailsCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<ChangeBankDetailsResponse> {
		let url_ = this.baseUrl + '/api/v1/BankDetails/ChangeBankDetails';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processChangeBankDetails(_response);
			});
	}

	protected processChangeBankDetails(response: AxiosResponse): Promise<ChangeBankDetailsResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ChangeBankDetailsResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ChangeBankDetailsResponse>(null as any);
	}
}

export interface IBillingSummaryClient {
	/**
	 * Get the Billing Summary by Policy Reference
	 * @return OK
	 */
	getSummary(): Promise<BillingSummaryResponse>;
	/**
	 * Get a Billing Summary by Policy Reference for the current term
	 * @return OK
	 */
	getSummaryForCurrentTerm(): Promise<BillingSummaryForCurrentTermResponse>;
}

export class BillingSummaryClient implements IBillingSummaryClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get the Billing Summary by Policy Reference
	 * @return OK
	 */
	getSummary(cancelToken?: CancelToken): Promise<BillingSummaryResponse> {
		let url_ = this.baseUrl + '/api/v1/BillingSummary/GetSummary';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetSummary(_response);
			});
	}

	protected processGetSummary(response: AxiosResponse): Promise<BillingSummaryResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<BillingSummaryResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<BillingSummaryResponse>(null as any);
	}

	/**
	 * Get a Billing Summary by Policy Reference for the current term
	 * @return OK
	 */
	getSummaryForCurrentTerm(cancelToken?: CancelToken): Promise<BillingSummaryForCurrentTermResponse> {
		let url_ = this.baseUrl + '/api/v1/BillingSummary/GetSummaryForCurrentTerm';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetSummaryForCurrentTerm(_response);
			});
	}

	protected processGetSummaryForCurrentTerm(response: AxiosResponse): Promise<BillingSummaryForCurrentTermResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<BillingSummaryForCurrentTermResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<BillingSummaryForCurrentTermResponse>(null as any);
	}
}

export interface IPaymentClient {
	/**
	 * Get the Payment Date for a policy reference
	 * @return OK
	 */
	getPaymentDay(): Promise<GetPaymentDayResponse>;
	/**
	 * Change the Payment Date for a policy
	 * @param body (optional) The change payment date model
	 * @return OK
	 */
	changePaymentDay(body: ChangePaymentDayCommand | undefined): Promise<ChangePaymentDayResponse>;
}

export class PaymentClient implements IPaymentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get the Payment Date for a policy reference
	 * @return OK
	 */
	getPaymentDay(cancelToken?: CancelToken): Promise<GetPaymentDayResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/GetPaymentDay';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPaymentDay(_response);
			});
	}

	protected processGetPaymentDay(response: AxiosResponse): Promise<GetPaymentDayResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetPaymentDayResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetPaymentDayResponse>(null as any);
	}

	/**
	 * Change the Payment Date for a policy
	 * @param body (optional) The change payment date model
	 * @return OK
	 */
	changePaymentDay(
		body: ChangePaymentDayCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<ChangePaymentDayResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/ChangePaymentDay';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processChangePaymentDay(_response);
			});
	}

	protected processChangePaymentDay(response: AxiosResponse): Promise<ChangePaymentDayResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ChangePaymentDayResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ChangePaymentDayResponse>(null as any);
	}
}

export interface IPaymentSessionClient {
	/**
	 * Captures a payment method on a session. The instrument is selected by the "$type" discriminator:
	 * "card" (physical card), "mobileCard" (Apple Pay / Google Pay) or "wallet" (e.g. PayPal).
	 * @param body (optional) The polymorphic command for the payment instrument being captured.
	 * @return OK
	 */
	captureSessionPaymentMethod(body: CaptureSessionPaymentMethodCommand | undefined): Promise<void>;
	/**
	 * @deprecated Use captureSessionPaymentMethod with "$type": "card".
	 * Captures payment method details on session
	 * @param body (optional) The command object containing all necessary details for capturing the payment method.
	 * @return OK
	 */
	capturePaymentMethod(body: CapturePaymentMethodCommand | undefined): Promise<void>;
}

export class PaymentSessionClient implements IPaymentSessionClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Captures a payment method on a session. The instrument is selected by the "$type" discriminator:
	 * "card" (physical card), "mobileCard" (Apple Pay / Google Pay) or "wallet" (e.g. PayPal).
	 * @param body (optional) The polymorphic command for the payment instrument being captured.
	 * @return OK
	 */
	captureSessionPaymentMethod(
		body: CaptureSessionPaymentMethodCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/PaymentSession/CaptureSessionPaymentMethod';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCaptureSessionPaymentMethod(_response);
			});
	}

	protected processCaptureSessionPaymentMethod(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * @deprecated Use captureSessionPaymentMethod with "$type": "card".
	 * Captures payment method details on session
	 * @param body (optional) The command object containing all necessary details for capturing the payment method.
	 * @return OK
	 */
	capturePaymentMethod(body: CapturePaymentMethodCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/PaymentSession/CapturePaymentMethod';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCapturePaymentMethod(_response);
			});
	}

	protected processCapturePaymentMethod(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}
}

export interface IScheduleClient {
	/**
	 * Get the billing schedule for a policy reference
	 * @return OK
	 */
	getBillingSchedule(): Promise<BillingScheduleResponse>;
}

export class ScheduleClient implements IScheduleClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get the billing schedule for a policy reference
	 * @return OK
	 */
	getBillingSchedule(cancelToken?: CancelToken): Promise<BillingScheduleResponse> {
		let url_ = this.baseUrl + '/api/v1/Schedule/GetBillingSchedule';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetBillingSchedule(_response);
			});
	}

	protected processGetBillingSchedule(response: AxiosResponse): Promise<BillingScheduleResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<BillingScheduleResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<BillingScheduleResponse>(null as any);
	}
}

export interface PaymentMethodResponse {
	$type: AllPaymentMethodDiscriminators;
	settlementMethodCode: SettlementMethodCode;
	description: string | undefined;
}

export interface BillingBankAccountPaymentMethodResponse extends PaymentMethodResponse {
	$type: 'BillingBankAccountPaymentMethod';
	sortCode: string;
	accountNumber: string;
	bankOrBuildingSociety: string;
}

export interface MspPaymentMethodResponse extends PaymentMethodResponse {
	provider: string | undefined;
}

export interface BillingCardPaymentMethodResponse extends MspPaymentMethodResponse {
	$type: 'BillingCardPaymentMethod';
	cardMethodType: CardMethodType;
	brand: string | undefined;
	last4Digits: string | undefined;
	expiryMonth: number;
	expiryYear: number;
}

export interface BillingFinanceHousePaymentMethodResponse extends PaymentMethodResponse {
	$type: 'BillingFinanceHousePaymentMethod';
	loanAgreementNumber: string | undefined;
}

export interface BillingMSPPaymentMethodResponse extends PaymentMethodResponse {
	$type: 'BillingMSPPaymentMethod';
	brand: string | undefined;
	last4Digits: string | undefined;
	expiryMonth: number;
	expiryYear: number;
	settlementProvider: string | undefined;
}

export interface BillingOffSystemPaymentMethodResponse extends PaymentMethodResponse {
	$type: 'BillingOffSystemPaymentMethod';
}

export interface BillingScheduleCollectionResponse {
	id: string;
	dueDate: string;
	scheduledDate: string;
	lastRequestedDate?: string | undefined;
	amount: number;
	status: PaymentStatus;
	reference: string;
	collectionType: CollectionType;
	paymentMethod?: AnySpecificPaymentMethodResponse | undefined;
	overdue: boolean;
	originalAmount: number;
	feeAmount: number;
}

export interface BillingScheduleResponse {
	schedules?: BillingTermScheduleResponse[] | undefined;
	canChangeBankDetails?: boolean;
}

export interface BillingSummaryForCurrentTermResponse {
	billingTerm?: BillingTermSummaryResponse;
}

export interface BillingSummaryResponse {
	billingTerms?: BillingTermSummaryResponse[] | undefined;
}

export interface BillingTermScheduleResponse {
	collections?: BillingScheduleCollectionResponse[] | undefined;
}

export interface BillingTermSummaryResponse {
	termNumber: number;
	termStart: string;
	termEnd: string;
	nextCollectionDate: string;
	currentPaymentMethod?: AnySpecificPaymentMethodResponse | undefined;
}

export interface BillingWalletPaymentMethodResponse extends MspPaymentMethodResponse {
	identifier: string | undefined;
}

export interface CapturePaymentMethodCommand {
	sessionCorrelationId: string | undefined;
	cardToken: string | undefined;
	cardType: string | undefined;
	last4Digits: string | undefined;
	deviceData: string | undefined;
	expiryMonth: number;
	expiryYear: number;
	saveCard: boolean;
}

/**
 * Base command for CaptureSessionPaymentMethod. The concrete instrument is chosen by the "$type"
 * discriminator, which must be the first property in the serialised JSON body:
 * "card" | "mobileCard" | "wallet".
 */
export interface CaptureSessionPaymentMethodCommand {
	$type: string;
	sessionCorrelationId: string;
	deviceData: string;
	savePaymentMethod: boolean;
}

/** "$type": "card" — a physical card, carrying card-visible data (expiry, card type, last four). */
export interface CaptureCardSessionPaymentMethodCommand extends CaptureSessionPaymentMethodCommand {
	$type: 'card';
	cardToken: string;
	cardType: string;
	last4Digits: string;
	expiryMonth: number;
	expiryYear: number;
}

/** "$type": "mobileCard" — Apple Pay / Google Pay; distinguished by cardMethodType. */
export interface CaptureMobileCardSessionPaymentMethodCommand extends CaptureSessionPaymentMethodCommand {
	$type: 'mobileCard';
	cardToken: string;
	cardMethodType: CardMethodType;
}

/** "$type": "wallet" — a wallet such as PayPal. */
export interface CaptureWalletSessionPaymentMethodCommand extends CaptureSessionPaymentMethodCommand {
	$type: 'wallet';
	walletToken: string;
	walletName: string;
	identifierType: WalletIdentifierType;
	identifierValue: string;
}

export enum WalletIdentifierType {
	EMAIL = 'EMAIL',
	MOBILE = 'MOBILE',
}

export enum CardMethodType {
	CARD = 'CARD',
	APPLE_PAY = 'APPLE_PAY',
	GOOGLE_PAY = 'GOOGLE_PAY',
}

export interface ChangeBankDetailsCommand {
	sortCode?: string | undefined;
	accountName?: string | undefined;
	accountNumber?: string | undefined;
}

export interface ChangeBankDetailsResponse {
	success?: boolean;
}

export interface ChangePaymentDayCommand {
	collectionDay?: number;
}

export interface ChangePaymentDayResponse {
	newPaymentDay?: number | undefined;
	nextPaymentCollection?: string | undefined;
}

export enum CollectionType {
	COLLECTION = 'COLLECTION',
	REFUND = 'REFUND',
}

export enum DissallowPaymentDateChangeReason {
	HasChangedPaymentDateThisTerm = 'HasChangedPaymentDateThisTerm',
	IsOnLastInstallment = 'IsOnLastInstallment',
	HasNotPaidFirstInstallment = 'HasNotPaidFirstInstallment',
	CurrentInstallmentRequested = 'CurrentInstallmentRequested',
	CurrentInstallmentSuspended = 'CurrentInstallmentSuspended',
	CurrentInstallmentCancelled = 'CurrentInstallmentCancelled',
	CurrentInstallmentInSp = 'CurrentInstallmentInSp',
}

export interface GetPaymentDayResponse {
	paymentDay?: number;
	canChangePaymentDay?: boolean;
	changePaymentDayReasons?: DissallowPaymentDateChangeReason[] | undefined;
	availableCollectionDays?: number[] | undefined;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
	errors?: any | undefined;

	[key: string]: any;
}

export enum PaymentStatus {
	SCHEDULED = 'SCHEDULED',
	REPLACED = 'REPLACED',
	CANCELLED = 'CANCELLED',
	SUSPENDED = 'SUSPENDED',
	REQUESTED = 'REQUESTED',
	FAILED = 'FAILED',
	AUTHORISED = 'AUTHORISED',
	SETTLED = 'SETTLED',
	REJECTED = 'REJECTED',
	CONSOLIDATED = 'CONSOLIDATED',
	REDUNDANT = 'REDUNDANT',
	OVERDUE = 'OVERDUE',
	FAILED_AND_REPLACED = 'FAILED_AND_REPLACED',
	SCHEDULED_OFF_SYSTEM = 'SCHEDULED_OFF_SYSTEM',
}

export enum SettlementMethodCode {
	CARD = 'CARD',
	DDM = 'DDM',
	MSP = 'MSP',
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
